import { useMediaQuery } from '@mantine/hooks';

export function useResponsiveness() {
  const isMobile = useMediaQuery('(max-width: 1023px)');

  return { isMobile };
}
